import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { MenuService } from './menu.service';

export const Ng1MenusModule = angular
  .module('control-room.shared.services.menus', [])
  .factory('crMenusService', downgradeInjectable(MenuService));
